export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <footer className="bg-forest-800 text-white relative overflow-hidden">
      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="relative">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid md:grid-cols-4 gap-12">
            {/* Column 1 - About */}
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/cb1950af-05a2-4ad4-b869-128c68de74e3.png"
                alt="あさぎり荘"
                className="h-12 w-auto mb-4"
              />
              <p className="text-white/70 text-sm leading-relaxed">
                ハチ高原の自然に寄り添い、森に包まれるやすらぎの時間をお過ごしいただけます。
              </p>
            </div>

            {/* Column 2 - Site Map */}
            <div>
              <h3 className="font-semibold text-white/80 mb-4 text-sm uppercase tracking-wider">
                サイトマップ
              </h3>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => scrollToSection('cuisine')}
                    className="text-white hover:text-gold-400 transition-colors text-sm cursor-pointer"
                  >
                    料理
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('camp')}
                    className="text-white hover:text-gold-400 transition-colors text-sm cursor-pointer"
                  >
                    合宿
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('pricing')}
                    className="text-white hover:text-gold-400 transition-colors text-sm cursor-pointer"
                  >
                    料金
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('access')}
                    className="text-white hover:text-gold-400 transition-colors text-sm cursor-pointer"
                  >
                    アクセス
                  </button>
                </li>
              </ul>
            </div>

            {/* Column 3 - Quick Links */}
            <div>
              <h3 className="font-semibold text-white/80 mb-4 text-sm uppercase tracking-wider">
                クイックリンク
              </h3>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => scrollToSection('introduction')}
                    className="text-white hover:text-gold-400 transition-colors text-sm cursor-pointer"
                  >
                    民宿について
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('cta')}
                    className="text-white hover:text-gold-400 transition-colors text-sm cursor-pointer"
                  >
                    ご予約
                  </button>
                </li>
              </ul>
            </div>

            {/* Column 4 - Contact */}
            <div>
              <h3 className="font-semibold text-white/80 mb-4 text-sm uppercase tracking-wider">
                お問い合わせ
              </h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start space-x-2">
                  <i className="ri-phone-line text-gold-400 mt-1"></i>
                  <a
                    href="tel:079-667-8119"
                    className="text-white hover:text-gold-400 transition-colors cursor-pointer"
                  >
                    079-667-8119
                  </a>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-printer-line text-gold-400 mt-1"></i>
                  <span className="text-white">079-667-8158</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-time-line text-gold-400 mt-1"></i>
                  <span className="text-white">
                    チェックイン
                    <br />
                    15:00〜19:00
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Large Logo */}
        <div className="border-t border-white/10 py-12 overflow-hidden">
          <h2 className="font-serif text-[#e8dcc4] text-7xl md:text-9xl font-bold text-center tracking-[0.2em] opacity-30">
            ASAGIRISOU
          </h2>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-6">
          <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm">
              &copy; 2025 あさぎり荘. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>

        {/* Scroll to Top Button */}
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-gold-600 text-white rounded-full shadow-lg hover:bg-gold-700 transition-all duration-300 transform hover:scale-110 flex items-center justify-center cursor-pointer z-40"
          aria-label="トップに戻る"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
        </button>
      </div>
    </footer>
  );
}